<template>
  <div
    v-if="cantidades.length > 0"
    class="selector-cantidad"
  >
    <span class="selector-label">Cantidad :</span>
    <el-select
      :model-value="modelValue"
      :disabled="disabled"
      placeholder="Seleccionar cantidad"
      size="default"
      style="min-width: 280px"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <el-option
        v-for="(item, index) in cantidades"
        :key="item[itemKey]"
        :label="`Alternativa ${index + 1} (${formatearCantidadVenta(item.cantidad)} ${item.unidadVenta || 'unidades'})`"
        :value="item[itemKey]"
      />
    </el-select>
  </div>
</template>

<script setup>
import { formatearCantidadVenta } from '@/shared/utils/cantidad_unidad_venta.js';

defineProps({
  modelValue: {
    type: [Number, String],
    default: null,
  },
  cantidades: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  itemKey: {
    type: String,
    default: 'codigoCotizacionCantidad',
  },
});

defineEmits(['update:modelValue']);
</script>

<style scoped>
.selector-cantidad {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.selector-label {
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}
</style>
